<template>
  <v-navigation-drawer
    class="menu-side-nav-padding-top"
    color="#f6f5f4"
    style="z-index: 0"
    width="256"
    fixed
    floating
    permanent
  >
    <div
      v-if="menuItems"
      class="color-black-magic d-flex flex-column menu-side-nav-padding"
    >
      <v-btn
        class="mb-1 d-flex justify-start"
        :class="{ 'active-side-nav': section === selectedSection }"
        v-for="(items, section) in menuItems"
        :key="section.replace(/^\d/, 'abc$&')"
        :to="{
          name: 'menu',
          hash: `#${slug(section.replace(/^\d/, 'abc$&'))}`,
        }"
        @click="section === selectedSection && $store.commit('menu/RESET_PAGE')"
        min-height="40"
        rounded
        text
      >
        <span
          style="max-width: 208px"
          class="d-inline-block font-size-md no-uppercase text-truncate"
          >{{ section }}
        </span>
      </v-btn>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { slug } from "github-slugger";
import { mapGetters } from "vuex";

export default {
  name: "MenuSideNav",
  computed: {
    ...mapGetters('menu', {
      menuItems: 'bySection',
      selectedSection: 'selectedSection',
    }),
  },
  methods: {
    slug,
  },
};
</script>

<style scoped>
.active:hover::before,
.theme--light.v-btn--active::before {
  opacity: 0;
}

.active-side-nav {
  background-color: var(--v-primary-base);
  color: var(--color-white) !important;
}

.menu-side-nav-padding {
  padding-right: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
}

.menu-side-nav-padding-top {
  padding-top: 249px;
}
</style>
